import React, { Component } from 'react';
import className from 'classnames';
import style from './field.row.less';
import Tooltip from '../form.components/tooltip/tooltip.jsx';

export default class FieldRow extends Component {
    render() {
        const { number, children, fieldValues, isActive } = this.props;
        const { title, condition, disableNumber, helpText } = this.props.props;
        let isOpen = true;
        if ('function' === typeof condition) { isOpen = condition(fieldValues); }
        if (!isOpen) { return null; }
        return (
            <div>
                <div className={style.fieldRow}>
                    {
                        !disableNumber
                        ? <span className={className(style.fieldRow__number, { [style.disabled]: !isActive })}>{number}</span>
                        : null
                    }
                    {
                        title
                        ?   <div className={style.fieldRow__section}>
                                <h2 className={style.fieldRow__header}>
                                    {title}
                                    { helpText
                                        ? <Tooltip helpText={helpText} />
                                        : null
                                    }
                                </h2>
                            </div>
                        : null
                    }
                    <div className={style.fieldRow__section}>
                        <div className={style.fieldRow__fieldWrapper}>
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
